import { useExistingCart } from "Components/Features/CheckPrice/hooks/checkPriceHooks";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { MainPath } from "Constants/constants";
import { buttonTrackId } from "Utils/analytics";
import React, { ReactElement } from "react";
import { useHistory } from "react-router";
import { ShoppingCartWrapper } from "./styled";

export const ShoppingCart = (): ReactElement | null => {
  const cartEntity = useExistingCart();
  const history = useHistory();

  if (!cartEntity.current) {
    return null;
  }

  const cartId = cartEntity.current.cartId;
  const numberOfItemsInCart = cartEntity.current.products.length;

  if (numberOfItemsInCart === undefined || numberOfItemsInCart === 0) {
    return null;
  }

  return (
    <ShoppingCartWrapper>
      <ThemedButton
        onClick={() => history.push(`/${MainPath.OFFER}/${cartId}`)}
        id="go-to-shopping-cart-button"
        trackId={buttonTrackId("go-to-shopping-cart-button")}
        type="button"
        iconLeft="shopping-basket-in"
        variant="text"
        size={24}
        style={{
          width: "fit-content",
        }}
      ></ThemedButton>
      <span className="number">{numberOfItemsInCart}</span>
    </ShoppingCartWrapper>
  );
};
